import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class StudentService {
  static ENDPOINT = `${BASE}/student`;

  static async create(studentCreate, auth = false, registrationToken = null) {
    const headers = registrationToken ? { 'X-Registration-Token': registrationToken } : {};
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      body: studentCreate,
      headers,
      auth
    })
  }
  
  static async get(FK_Contact) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(FK_Contact)}`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async update(id, studentUpdate) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'PUT',
      body: studentUpdate
    })
  }

  static async delete(FK_Contact) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(FK_Contact)}`,
      method: 'DELETE',
      headers: {'Accept': 'application/json'}
    })
  }
}

export default StudentService;
